export const FETCH_LOGIN_BY_TOKEN_REQUEST = 'FETCH_LOGIN_BY_TOKEN_REQUEST'
export const FETCH_LOGIN_BY_TOKEN_SUCCESS = 'FETCH_LOGIN_BY_TOKEN_SUCCESS'
export const FETCH_LOGIN_BY_TOKEN_FALUIRE = 'FETCH_LOGIN_BY_TOKEN_FALUIRE'
export const FETCH_CLEAR_ERROR_MESSAGE_FALUIRE = 'FETCH_CLEAR_ERROR_MESSAGE_FALUIRE'
